angular.module 'zc.projects'
.controller 'SettingsCtrl', (
    $filter
    $injector
    $scope
    $state
    $stateParams
    $translate
    Page
    Devise
    Project
    PageType
    SettingStatus
    ProjectExcludeIp
    currentProject
    invoiceCalculationTypes
    paymentMethods
    invoiceIssueDays
    invoiceDueDays
    invoicePaymentDays
    invoicePaymentMonths
    excludeIps
    contractStatuses
    trialInvoiceCalculationTypes
    sessionCountEvaluators
    domainLinkTypes
    projectRanks
    productLines
    currencies
    regions
    optTargets
    pricingTypes
    ip
    noPublishPageTypes
    masterUsers
    FacadeV2) ->

  MAX_CHANNEL_NAME_LENGTH = 21
  CLIENT_CHANNEL_PREFIX_LENGTH = 2
  MAXIMUM_APIKEY_LENGTH = MAX_CHANNEL_NAME_LENGTH - CLIENT_CHANNEL_PREFIX_LENGTH

  # This exists also in project.rb
  DEFAULT_TIER_PRICING_FEE_RATE = 0.04

  # Sub KPI (opt_target) options based on product lines
  SUB_KPI_OPTS_ZENCLERK = ['display_cv_value', 'acquired_cv_value']
  SUB_KPI_OPTS_ZENCLERK_LP = ['display_cv_count', 'acquired_cv_count']

  $scope.maximumApikeyLength = MAXIMUM_APIKEY_LENGTH
  $scope.ip = ip
  $scope.SettingStatus = SettingStatus
  $scope.project = currentProject
  $scope.contractStatuses = contractStatuses
  $scope.trialInvoiceCalculationTypes = trialInvoiceCalculationTypes
  $scope.invoiceCalculationTypes = invoiceCalculationTypes
  $scope.paymentMethods = paymentMethods
  $scope.invoiceIssueDays = invoiceIssueDays
  $scope.invoiceDueDays = invoiceDueDays
  $scope.invoicePaymentDays = invoicePaymentDays
  $scope.invoicePaymentMonths = invoicePaymentMonths
  $scope.sessionCountEvaluators = sessionCountEvaluators
  $scope.domainLinkTypes = domainLinkTypes
  $scope.projectRanks = projectRanks
  $scope.masterUsers = _.cloneDeep(masterUsers)
  $scope.currencies = currencies
  # Use $injector to get the constant currencies defined in frontend as there
  # is a name conflict between the resolve.currencies and constant currencies
  $scope.currency = $injector.get('currencies')[currentProject.currency]
  $scope.regions = regions
  $scope.optTargets = optTargets
  $scope.productLines = productLines
  $scope.pricingTypes = pricingTypes
  $scope.noPublishPageTypes = noPublishPageTypes
  $scope.isMaster = Devise.isMaster()
  $scope.isCommon = Devise.isCommonUser()
  $scope.appUrl = ZC_CONFIG.AIDEAL_URL

  $scope.project.is_reviewed = !!currentProject.reviewed_at
  $scope.project.is_suspended = !!currentProject.suspended_at
  $scope.project.is_region_set = !!currentProject.region

  $scope.noPublishPageTypeLimit = 5000
  $scope.noPublishPageTypesVisibleLimit = 50
  $scope.minChargeTierPricingTable = null
  $scope.isMinChargeShouldChanged = false

  Page.setBodyClass ''
  $translate('projectsSettings.index.editSiteSetting').then (translation) ->
    Page.setTitle translation

  SettingStatus.updateProjectStatus currentProject
  SettingStatus.updateExcludeIpStatus excludeIps

  $scope.completeInitialization = (project) ->
    Project.update
      projectId: project.id
    ,
      project:
        installed_at: moment().startOf('day').toDate()
    .then updateProject

  $scope.completeInstallation = (project) ->
    Project.update
      projectId: project.id
    ,
      project:
        campaign_status: 'completed'
    .then (project) ->
      updateProject project
      $state.go 'admin.projects.campaigns.list',
        projectId: currentProject.id

  $scope.save = (project) ->
    Project.update
      projectId: project.id
    ,
      project: project
    .then updateProject


  $scope.remove = (project) ->
    Project.remove
      projectId: project.id
    .then () ->
      $state.go 'admin.users.edit'
    .catch (err) ->
      alertify.error(err.data.message)

  updateProject = (project) ->
    $scope.project = project
    SettingStatus.updateProjectStatus $scope.project
    $scope.project.is_reviewed = !!project.reviewed_at
    $scope.project.is_suspended = !!project.suspended_at
    $scope.project.is_region_set = !!currentProject.region

  $scope.updateSuspendedAt = () ->
    if $scope.project.is_suspended
      $scope.project.suspended_at = $filter('changeDatetimeFrom')('localToRegion', moment().startOf('day').toDate(), 'string')
    else
      $scope.project.suspended_at = null

  $scope.addNoPublishPageType = ->
    $scope.noPublishPageTypes.push(PageType.new
      project_id: currentProject.id
      page_type: 'no_publish'
      match_pattern: '/'
      match_type: null
    )

  $scope.onDestroyNoPublishPageType = (pageType) ->
    return unless pageType
    index = $scope.noPublishPageTypes.indexOf pageType
    $scope.noPublishPageTypes.splice index, 1

  $scope.$on 'uploadedPageTypes', (event, pageTypes) ->
    $scope.noPublishPageTypes = _.filter(pageTypes, { page_type: 'no_publish' });

  parser = window.document.createElement('a');
  parser.href = $scope.project.base_url;
  $scope.baseUrl = parser.origin

  $scope.setNoPublishPageTypesVisibleLimit = (limit) ->
    $scope.noPublishPageTypesVisibleLimit = limit

  $scope.removePageTypes = ->
    Project.removePageTypes
      projectId: $scope.project.id
      page_type: 'no_publish'
    .then (res) ->
      $scope.noPublishPageTypes = []

  $scope.$watch 'project.product_line', () ->
    if $scope.project.product_line != 'zenclerk' && $scope.project.pricing_type == 'tiered'
      $scope.project.pricing_type = 'volume'
    if $scope.project.product_line == 'zenclerk'
      $scope.optTargets = _.filter optTargets, (opt) -> SUB_KPI_OPTS_ZENCLERK.includes(opt.name)
      if !SUB_KPI_OPTS_ZENCLERK.includes($scope.project.opt_target)
        $scope.project.opt_target = null
    else if $scope.project.product_line == 'zenclerk_lp'
      $scope.optTargets = _.filter optTargets, (opt) -> SUB_KPI_OPTS_ZENCLERK_LP.includes(opt.name)
      if !SUB_KPI_OPTS_ZENCLERK_LP.includes($scope.project.opt_target)
        $scope.project.opt_target = null
    else
      $scope.project.opt_target = null

  $scope.$watch 'project.pricing_type', (newValue, oldValue) ->
    if oldValue == 'volume' && newValue == 'tiered'
      $scope.project.fee_rate = DEFAULT_TIER_PRICING_FEE_RATE

  $scope.$watch 'project.cookie_server_enabled', () ->
    if !$scope.project.cookie_server_enabled
      $scope.project.cookie_server_client_fqdn = null
      $scope.project.cookie_server_aiqua_fqdn = null

  updateMinimumCharge = () ->
    if $scope.project.pricing_type == 'minimum_charge' && !!$scope.project.minimum_charge && $scope.isMinChargeShouldChanged
      # copy pricing table without last tier, which only includes `from`
      pricingTable = $scope.minChargeTierPricingTable.slice(0, -1)
      if $scope.project.minimum_charge < (Number) pricingTable[0].fee
        targetedTier = pricingTable[0]
      else
        targetedTier = _.find(pricingTable.reverse(), (tier) -> $scope.project.minimum_charge >= (Number) tier.fee)
      $scope.project.minimum_usage = (Number) targetedTier.to
      $scope.isMinChargeShouldChanged = false

  updateMinChargeTierPricingTable = () ->
    FacadeV2.request "/master/min_charge_tier_pricing_table?cpa=#{$scope.project.base_cpa}&currency=#{$scope.project.currency}", {}
      .then (res) ->
        if res.data
          $scope.minChargeTierPricingTable = res.data.pricing_table
          $scope.isMinChargeShouldChanged = true

  $scope.$watch 'project.base_cpa', (newValue, oldValue) ->
    if !!(newValue - oldValue) && $scope.project.pricing_type == 'minimum_charge' && !!$scope.project.base_cpa
      updateMinChargeTierPricingTable()
      updateMinimumCharge()

  $scope.$watch 'project.minimum_charge', (newValue, oldValue) ->
    if !!(newValue - oldValue)
      $scope.isMinChargeShouldChanged = true
      updateMinimumCharge()



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.settings/index.controller.coffee